/** @jsx _j **/

/** @jsxFrag _f **/
var _require = require('astroturf'),
    _j = _require.jsx,
    _f = _require.F;

import DocumentOutline from './DocumentOutline';
import Navbar from './Navbar';
import SideNavigation from './SideNavigation';

/** @public */
function PageLayout(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style;
  return _j("div", {
    className: className,
    style: style,
    css: [require("./PageLayout-CssProp1_div.module.css"), []]
  }, _j(Navbar, null), _j("div", {
    css: [require("./PageLayout-CssProp2_div.module.css"), []]
  }, _j(SideNavigation, {
    css: [require("./PageLayout-CssProp3_SideNavigation.module.css"), []]
  }), _j(DocumentOutline, {
    css: [require("./PageLayout-CssProp4_DocumentOutline.module.css"), []]
  }), _j("main", {
    css: [require("./PageLayout-CssProp5_main.module.css"), []]
  }, children)));
}

export default PageLayout;